const uiVars = window.ACE_PPH_UI_VARS;
if (!uiVars) {
  alert("No UI Vars found");
}
export default uiVars;
